import { useCallback, useEffect, useState } from "react";
import FilterContent from "../../../../../components/Filter/FilterContent";
import {
  useLeadsContainerStore,
  useLeadsStore,
} from "../../../../../stores/LeadsStore";
import { useProfileStore } from "../../../../../stores/UserStore";
import PopOver from "../../../../../components/View/PopOver";
import { IconAdjustmentsHorizontal, IconX } from "@tabler/icons-react";
import { Button, Group, Indicator, Modal, Tooltip } from "@mantine/core";
import { useLanguage } from "../../../../../stores/LanguageStore";
import FilterContentMobile from "../../../../../components/Filter/mobile/FilterContentMobile";

const LeadsFilterMobile = () => {
  const lang = useLanguage((s) => s.language);
  const filter = useLeadsStore((s) => s.filter);
  const filters = useLeadsStore((s) => s.filters);
  const setFilter = useLeadsStore((s) => s.setFilter);
  const setReloadAll = useLeadsContainerStore((s) => s.setReloadAll);

  const [opened, setOpened] = useState(false);
  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  const profile = useProfileStore((s) => s.profile);

  const handleFilter = useCallback(
    (newFilter) => {
      setFilter(newFilter);
      setReloadAll(true);
    },
    [setFilter, setReloadAll]
  );

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    let prog = urlParams.get("programmation_id");
    let created_on = urlParams.get("created_on");
    let contact_type = urlParams.get("contact_type");
    let contact_id = urlParams.get("contact_id");
    let defaultFilter = urlParams.get("filter");

    if (prog && created_on) {
      let v = [
        {
          field_name: "programmation_id",
          type: "equals",
          value: prog,
        },
      ];
      if (contact_type) {
        v.push({
          field_name: contact_type,
          type: "more_than",
          value: created_on,
        });
      }

      setFilter({
        mode: "and",
        values: v,
      });
    } else {
      if (contact_id) {
        setFilter({
          mode: "and",
          values: [
            {
              field_name: "id",
              type: "equals",
              value: contact_id,
            },
          ],
        });
      } else {
        if (defaultFilter) {
          setFilter(JSON.parse(defaultFilter));
        } else {
          setFilter(
            profile?.saved_filters?.prm?.find((x) => x?.pinned === true)
              ?.filter || null
          );
        }
      }
    }
  }, []);

  return (
    <>
      <Group gap={0}>
        <Tooltip label={lang.table.toolbar.filter.main_button_tooltip}>
          <Indicator
            color="red"
            offset={2}
            disabled={!filter || filter?.values?.length === 0}
            label={filter?.values?.length}
            styles={{
              indicator: {
                fontSize: 9,
                padding: "6px",
              },
            }}
          >
            <Button
              onClick={handleOpen}
              radius={"md"}
              variant={"subtle"}
              className="test"
              style={{
                borderColor: "var(--mantine-color-primary-0)",
                background: "#fff",
                borderTopRightRadius: filter?.values?.length > 0 ? 0 : 8,
                borderBottomRightRadius: filter?.values?.length > 0 ? 0 : 8,
              }}
              id={"table-filter-prm"}
            >
              <IconAdjustmentsHorizontal size={20} />
            </Button>
          </Indicator>
        </Tooltip>
        {filter?.values?.length > 0 && (
          <Tooltip label={lang.table.toolbar.filter.cancel_button_tooltip}>
            <Button
              variant="light"
              color="red"
              px={4}
              style={{
                borderLeft: "none",
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
              }}
              onClick={() => handleFilter(null)}
            >
              <IconX size={18} />
            </Button>
          </Tooltip>
        )}
      </Group>

      <Modal opened={opened} onClose={handleClose} title={lang.table.toolbar.filter.main_button_label}>
        <FilterContentMobile
          id={"prm-filter"}
          isClient={false}
          pageName={"prm"}
          mainFilter={filter}
          setMainFilter={(newFilter) => {
            handleFilter(newFilter);
            handleClose();
          }}
          fields={filters}
          getFieldOptionName={(f) => f.option_name}
          // defaultFiltersClose={true}
        />
      </Modal>
    </>
  );
};

export default LeadsFilterMobile;
